export const internal = Symbol("xendit-internal");
